import { defineMessages } from "react-intl";

export default defineMessages({
  superTalentGoal: {
    id: "repeatRate.superTalentGoal",
    defaultMessage:
      "<superTalentBadge></superTalentBadge> Objectif SuperTalent",
  },
  score_value: {
    id: "repeatRate.scoreValue",
    defaultMessage: "{score} %",
  },
  improveScore: {
    id: "repeatRate.improveScore",
    defaultMessage: "Comment améliorer le score",
  },
  seeMore: {
    id: "repeatRate.seeMore",
    defaultMessage: "Voir plus <RightIcon></RightIcon>",
  },
  share_profile: {
    id: "repeatRate.shareProfile",
    defaultMessage: "Partagez votre profil à vos clients",
  },
  respect_rules: {
    id: "repeatRate.respectRules",
    defaultMessage: "Respectez les règles du jeu !",
  },
  how_to_super: {
    id: "repeatRate.howToSuper",
    defaultMessage: "Comment atteindre l'objectif SuperTalent",
  },
  do_jobs: {
    id: "repeatRate.doJobs",
    defaultMessage: "Réalisez des jobs pour atteindre l’objectif SuperTalent",
  },
  ask_questions: {
    id: "repeatRate.askQuestions",
    defaultMessage:
      "Posez les bonnes questions au client ou à la cliente avant qu'il ou elle ne vous choisisse.",
  },
  discover_advice: {
    id: "repeatRate.discoverAdvice",
    defaultMessage:
      "Découvrez nos conseils pour augmenter votre taux de réalisation.",
  },
  share_profile_title: {
    id: "repeatRate.shareProfileTitle",
    defaultMessage: "Partagez votre profil à vos clients",
  },
  share_profile_core: {
    id: "repeatRate.shareProfileCore",
    defaultMessage:
      "Vous retravaillez avec un client mais ne savez pas comment créer un job sur la plateforme ? Partagez votre profil à votre client. Il pourra alors créer une demande uniquement pour vous. A vous de l'accepter ou non.",
  },
  respect_rules_title: {
    id: "repeatRate.respectRulesTitle",
    defaultMessage: "Respectez les règles de jeu !",
  },
  respect_rules_core: {
    id: "repeatRate.respectRulesCore",
    defaultMessage:
      "Vous vous présentez à nouveau chez un client ? Passez toujours via Ring Twice ! Vous respectez ainsi <bold>les règles du jeu.</bold> De plus, le service est <bold>assuré et déclaré.</bold> Si vous passez en dehors, nous pouvons suspendre votre compte.",
  },
  how_to_core: {
    id: "repeatRate.howToCore",
    defaultMessage:
      "Passez via Ring Twice quand vous retravaillez avec un client et celui-ci deviendra un client dit récurrent.L'objectif SuperTalent <bold>dépend de votre catégorie de service.</bold> Cela veut dire que ce seuil est différent en fonction du type de service que vous rendez.",
  },
  share_my_profile: {
    id: "repeatRate.shareMyProfile",
    defaultMessage: "Partager mon profil",
  },
  do_jobs_title: {
    id: "realisationRate.doJobsTitle",
    defaultMessage: "Réalisez des jobs",
  },
  do_jobs_core: {
    id: "realisationRate.doJobsCore",
    defaultMessage:
      "Pour augmenter votre taux de réalisation, il vous faut réaliser des jobs. Tout en évitant les annulations. Si un job devait être annulé, pas de panique. Comme votre taux est basé sur les 12 derniers mois, <bold>une annulation n'a pas d'impact à vie</bold> !",
  },
  ask_questions_title: {
    id: "realisationRate.askQuestionsTitle",
    defaultMessage: "Communiquez avec le client",
  },
  ask_questions_core: {
    id: "realisationRate.askQuestionsCore",
    defaultMessage:
      "Avant que le client/ la cliente vous choisisse, il est important de se mettre d’accord sur : <break></break><break></break>• Pour quand le travail doit-il être réalisé ?Suis-je disponible ?<break></break>• Y-a-t-il du matériel sur place ou est-ce que je dois amener le mien ?<break></break>• Quel est plus ou moins votre budget ?<break></break>• Quelle est la description complète du travail ?",
  },
  discover_advice_title: {
    id: "realisationRate.discoverAdviceTitle",
    defaultMessage: "Une annulation, ça peut disparaitre",
  },
  discover_advice_core: {
    id: "realisationRate.discoverAdviceCore",
    defaultMessage:
      "Le taux de réalisation est basé sur les 12 derniers mois, <bold>une annulation n'a donc pas d'impact à vie</bold> !",
  },
  dateComputed: {
    id: "superTalent.dateComputed",
    defaultMessage: "<calendar></calendar>Calculés sur 12 mois",
  },
  no_information: {
    id: "superTalent.noInformation",
    defaultMessage: "-",
  },
  score: {
    id: "repeatRate.score",
    defaultMessage: "Votre score",
  },
  recurrentClients: {
    id: "repeatRate.recurrentClients",
    defaultMessage: "Clients récurrents",
  },
  totalClients: {
    id: "repeatRate.totalClients",
    defaultMessage: "Clients total",
  },
  closedServices: {
    id: "realisationRate.closedServices",
    defaultMessage: "Jobs clôturés",
  },
  cancelledServices: {
    id: "realisationRate.cancelledServices",
    defaultMessage: "Jobs annulés",
  },
  blocked: {
    id: "superTalent.blocked",
    defaultMessage:
      "Vous ne pouvez malheureusement plus postuler à cause de votre taux trop faible",
  },
  warning: {
    id: "superTalent.warning",
    defaultMessage:
      "Attention, vous approchez de la limite. Il y a moyen de s'améliorer.",
  },
  ok: {
    id: "realisationRate.ok",
    defaultMessage: "Continuez sur cette lancée !",
  },
  good: {
    id: "realisationRate.good",
    defaultMessage: "Vous êtes si proche du but !",
  },
  excellent: {
    id: "realisationRate.excellent",
    defaultMessage: "SuperTalent en vue !",
  },
  newbie: {
    id: "realisationRate.newbie",
    defaultMessage:
      "Décrochez votre premier job et accédez à votre taux de réalisation !",
  },
  finish_jobs: {
    id: "realisationRate.finishJobs",
    defaultMessage: "Passez à l’action: terminez vos jobs en cours",
  },
  current_jobs_questions: {
    id: "realisationRate.currentJobsQuestions",
    defaultMessage:
      "Candidatures en cours: soyez réactifs et posez les bonnes questions",
  },
  work_previous_clients: {
    id: "realisationRate.workPreviousClients",
    defaultMessage: "Travaillez avec des anciens clients",
  },
  finish_jobs_title: {
    id: "realisationRate.finishJobsTitle",
    defaultMessage: "Terminez vos jobs en cours",
  },
  finish_jobs_core: {
    id: "realisationRate.finishJobsCore",
    defaultMessage:
      "Pour augmenter votre taux de réalisation, clôturez vos jobs en cours si vous en avez. Plus vous clôturez de jobs, plus votre taux augmentera.",
  },
  current_jobs_questions_title: {
    id: "realisationRate.currentJobsQuestionsTitle",
    defaultMessage: "Candidatures en cours",
  },
  current_jobs_questions_core: {
    id: "realisationRate.currentJobsQuestionsCore",
    defaultMessage:
      "Essayez d'être sélectionné pour les jobs auxquels vous avez déjà fait une offre. Soyez réactif et posez les bonnes questions.",
  },
  work_previous_clients_title: {
    id: "realisationRate.workPreviousClientsTitle",
    defaultMessage: "Contactez vos anciens clients",
  },
  work_previous_clients_core: {
    id: "realisationRate.workPreviousClientsCore",
    defaultMessage:
      "Recontactez vos anciens clients via l'onglet Mes clients et proposez-leur de refaire appel à vos services via Ring Twice.",
  },
});
